__turbopack_context__.v({
  "description": "MultiVid-module__RbwfSG__description",
  "heading": "MultiVid-module__RbwfSG__heading",
  "imageContainer": "MultiVid-module__RbwfSG__imageContainer",
  "playButton": "MultiVid-module__RbwfSG__playButton",
  "playIcon": "MultiVid-module__RbwfSG__playIcon",
  "tabContent": "MultiVid-module__RbwfSG__tabContent",
  "tabs": "MultiVid-module__RbwfSG__tabs",
  "videoItem": "MultiVid-module__RbwfSG__videoItem",
  "videoItems": "MultiVid-module__RbwfSG__videoItems",
  "videoTitle": "MultiVid-module__RbwfSG__videoTitle",
  "wrapper": "MultiVid-module__RbwfSG__wrapper",
});
